import { HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { ITypeAheadResult } from "~app/common/models/type-ahead-result.model";
import { MarknadsprislistaSearchDTO } from "~app/common/models/virkeskop/v2/MarknadsprislistaSearchDTO";
import { ApiClientService } from "~app/common/services/api-client.service";
import {
    ICommandResult,
    IHandelssortimentsgrupp,
    IMarknadsprislista,
    IMarknadsprislistaSearchParamsModel,
    SaveMarknadsprislistaCommand
} from "../models/marknadsprislista-model";
import { IMarknadsomrade } from "../models/verksamhetsomraden-models";

@Injectable({
    providedIn: "root"
})
export class MarknadsprislistaService {
    private readonly apiClient = inject(ApiClientService);

    getMarknadsprislistor(searchParams: IMarknadsprislistaSearchParamsModel): Observable<IMarknadsprislista[]> {
        return this.apiClient.get<IMarknadsprislista[]>(`marknadsprislista?embed=resultatomraden,handelssortimentsgrupper`,false, searchParams);
    }

    searchMarknadsprislistor(searchParams: MarknadsprislistaSearchDTO): Observable<IMarknadsprislista[]> {
        return this.apiClient.post<MarknadsprislistaSearchDTO, IMarknadsprislista[]>(`marknadsprislista/search?embed=resultatomraden,handelssortimentsgrupper`,
            searchParams);
    }

    getMarknadsomrade(): Observable<IMarknadsomrade[]> {
        return this.apiClient.get<IMarknadsomrade[]>("verksamhetsomrade/marknadsomrade");
    }

    getHandelssortimentsgrupper(): Observable<IHandelssortimentsgrupp[]> {
        return this.apiClient.get(`handelssortimentsgrupp`);
    }

    deleteMarknadsprislista(id: number): Observable<boolean> {
        return this.apiClient.delete(`marknadsprislista/${id}`);
    }

    saveMarknadsprislista(target: IMarknadsprislista): Observable<ICommandResult> {
        return this.apiClient.post(`marknadsprislista`, new SaveMarknadsprislistaCommand(target));
    }

    getViolIdTypeAhead(input: string): Observable<ITypeAheadResult[]> {
        const subject = new Subject<ITypeAheadResult[]>();

        if (input.length < 3) {
            return subject.asObservable();
        }

        return this.apiClient.post<any, ITypeAheadResult[]>("marknadsprislista/violid/typeahead", JSON.stringify(input), false, null, this.getHeader());
    }

    private getHeader(): HttpHeaders {
        const headers = new HttpHeaders();
        return headers.append("content-type", "application/json");
    }
}
